import { gql } from '@apollo/client';

export const GET_WORKSPACE_DATASET_LINK = gql`
  query GetWorkspaceDatasetLink($id: ID!) {
    datasetLink: getWorkspaceDatasetLink(id: $id) {
      id
      description
      workspace {
        id
        funder {
          id
          name
        }
        institution {
          id
          name
        }
        serviceProvider {
          id
          name
        }
      }
    }
  }
`;
